import { createStore } from 'satcheljs';
import TaskModule, { DialogMap } from './schema/TaskModule';
import { Instances, InstanceStore } from './schema/TaskModuleInstances';
import { ObservableMap } from 'mobx';

export const taskModules = createStore<Instances>('taskModuleInstances', {
    instances: new Map<string, InstanceStore>(),
});

export const instanceFactory = (id: string): InstanceStore =>
    createStore<TaskModule>(`taskModuleInstance_${id}`, {
        isOpen: false,
        dialogInfo: new ObservableMap() as DialogMap,
    });
